import { useEffect, useState } from 'react';
import { useGetAllListingCommentsQuery } from '~/apis/monitoring/filter';
import { getListingTabGroup, parseDropDown, parseValueToValueArray } from '~/utils';
import { useLogger } from '~/hooks';
import { MarqCommonEnumsCommentCommentUserTypeEnum } from '~/swagger/data-contracts';
import { DropDown } from '../@types';
import { useGetFilterParams, usePathParams } from '.';

export const useListingCommentFilter = () => {
  const { listingStatus, domainType } = usePathParams();
  const { params, requestFilterParams, setParams, removeParams } = useGetFilterParams();
  const { amplitudeLogging } = useLogger();
  const { comment_user_type_filter } = params;
  const commentUserTypeFilter = parseValueToValueArray(comment_user_type_filter);

  const [value, setValue] = useState<MarqCommonEnumsCommentCommentUserTypeEnum | null>(
    commentUserTypeFilter?.length === 2
      ? MarqCommonEnumsCommentCommentUserTypeEnum.All
      : commentUserTypeFilter?.[0] || null
  );

  const listingCommentQuery = useGetAllListingCommentsQuery<DropDown<MarqCommonEnumsCommentCommentUserTypeEnum>>(
    {
      ...requestFilterParams,
      comment_user_type_filter: [],
    },
    {
      enabled: !!listingStatus,
      staleTime: 5000,
      select: parseDropDown,
    }
  );

  const handleSelect = (value: MarqCommonEnumsCommentCommentUserTypeEnum | null) => {
    setValue(value);
    if (value) {
      amplitudeLogging('applied filter', {
        Type: 'comments',
        Channel: domainType,
        Page: getListingTabGroup(listingStatus),
      });
      if (value === MarqCommonEnumsCommentCommentUserTypeEnum.All) {
        setParams(
          {
            comment_user_type_filter: [
              MarqCommonEnumsCommentCommentUserTypeEnum.Client,
              MarqCommonEnumsCommentCommentUserTypeEnum.Admin,
            ],
          },
          { replace: true }
        );
      } else if (value === MarqCommonEnumsCommentCommentUserTypeEnum.Admin) {
        setParams({ comment_user_type_filter: [value] }, { replace: true });
      } else {
        setParams({ comment_user_type_filter: [] }, { replace: true });
      }
    } else {
      removeParams('comment_user_type_filter');
    }
  };

  useEffect(() => {
    if (!commentUserTypeFilter || commentUserTypeFilter?.length === 0) {
      setValue(null);
    }
  }, [commentUserTypeFilter.length]);

  return {
    list: listingCommentQuery.data?.list || [],
    selected: value,
    disabled: listingCommentQuery.data?.list.length === 0,
    isFetching: listingCommentQuery.isFetching,
    select: handleSelect,
  };
};
